module.exports = __webpack_public_path__ + "static/img/loading_dots.71d2aae7.gif";